// extracted by mini-css-extract-plugin
module.exports = {"ErrorModal":"ErrorModal_ErrorModal__1wSH2","show":"ErrorModal_show__3A5KD"};